export default "__VITE_ASSET__CcskVyUm__"